/**
 * Image scaling for the viewport (characters + backgrounds), mirroring
 * the AO2 client's Automatic / Pixel / Smooth option.
 *   - automatic / pixel : crisp-edges (pixelated) -- correct for the
 *     pixel-art sprites and backgrounds AA content uses, matching the
 *     desktop client's default crisp look.
 *   - smooth            : the browser's default bilinear smoothing.
 * Applied as a class on <body> (which always exists, unlike the
 * golden-layout panes) so the CSS takes effect whenever the viewport
 * images are created. Persisted to localStorage.
 */
const CLASSES = ["scaling-automatic", "scaling-pixel", "scaling-smooth"];

export function setImageScaling(mode: string) {
  const cls =
    mode === "smooth"
      ? "scaling-smooth"
      : mode === "pixel"
        ? "scaling-pixel"
        : "scaling-automatic";
  document.body.classList.remove(...CLASSES);
  document.body.classList.add(cls);
  try {
    localStorage.setItem("webcoa_image_scaling", mode);
  } catch { /* private mode */ }
}

/** Restore saved scaling (default automatic = crisp) and sync the select. */
export function initImageScaling() {
  let mode = "automatic";
  try {
    mode = localStorage.getItem("webcoa_image_scaling") || "automatic";
  } catch { /* ignore */ }
  const sel = document.getElementById("client_imagescaling") as HTMLSelectElement | null;
  if (sel) sel.value = mode;
  setImageScaling(mode);
}

window.setImageScaling = setImageScaling;
window.initImageScaling = initImageScaling;

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initImageScaling);
} else {
  initImageScaling();
}
